import { isEmpty } from 'lodash/fp';

export function getColumnPropertiesFromColumnAttributes(columnProperties, columnAttributes) {
    if (isEmpty(columnProperties) || isEmpty(columnAttributes)) {
        return { description: columnProperties?.description, properties: [] };
    }
    const { description, ...restProperties } = columnProperties;

    const properties = Object.entries(restProperties).map(([key, value]) => {
        const { name } = columnAttributes.find((attr) => attr.uid === key);

        return { name, value };
    });

    return { description, properties };
}
